// Our base component, which all others extend.
import { customElement } from 'lit/decorators.js';
import '../../base/outline-container/outline-container';
import { OutlineBreadcrumbs } from '../../base/outline-breadcrumbs/outline-breadcrumbs';
import componentStyles from './idb-breadcrumbs.css.lit';
import { CSSResultGroup, html, TemplateResult } from 'lit';
/**
 * The IDB Breadcrumbs component
 * @element idb-breadcrumbs
 * @slot - The default only slot for this element.
 */

@customElement('idb-breadcrumbs')
export class IdbBreadcrumbs extends OutlineBreadcrumbs {
  static styles: CSSResultGroup = [OutlineBreadcrumbs.styles, componentStyles];
  /**
   * Overriding the firstUpdated() function from OutlineBreadcrumbs
   * in order to pass in our custom icon element for a separator.
   */
  firstUpdated(): void {
    const breadcrumbItems = this.querySelectorAll('span:not(:last-of-type)');
    breadcrumbItems.forEach(item => {
      const sep: HTMLSpanElement = document.createElement('outline-icon');
      sep.classList.add('separator');
      sep.setAttribute('name', 'arrow-right');
      sep.setAttribute('library', 'lucide');
      sep.setAttribute('size', '1em');
      item.after(sep);
    });
  }

  render(): TemplateResult {
    return html`
      <section class="outline-breadcrumbs">
        <outline-container>
          <outline-icon
            class="mobile-icon"
            name="chevron_left"
            library="material"
            size="1.4rem"
          ></outline-icon>
          <slot></slot>
        </outline-container>
      </section>
    `;
  }
}
